<div class="app-dropdown" [class.app-dropdown--open]="isOpen()">
  <div [class]="className()">
    @if (label()) {
      <label class="app-dropdown__label">{{ label() }}</label>
    }
    <div class="app-dropdown__control">
      <button
        #trigger
        type="button"
        class="app-dropdown__trigger"
        [class.app-dropdown__trigger--disabled]="disabled()"
        [style.min-width]="minWidth() || null"
        [style.max-width]="maxWidth() || null"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-haspopup]="'listbox'"
        aria-label="Abrir lista"
        (click)="toggle()"
        [disabled]="disabled()"
      >
        <span class="app-dropdown__trigger-text">{{ getDisplayLabel() }}</span>
        <span class="app-dropdown__trigger-icon" aria-hidden="true">
          <i class="iconify" data-icon="solar:alt-arrow-down-outline"></i>
        </span>
      </button>
      @if (isOpen()) {
        <div
          #panel
          class="app-dropdown__panel custom-scrollbar"
          [class.app-dropdown__panel--overlay]="overlay()"
          [class.app-dropdown__panel--top]="!overlay() && position() === 'top'"
          [class.app-dropdown__panel--bottom]="!overlay() && position() === 'bottom'"
          [class.app-dropdown__panel--left]="!overlay() && position() === 'left'"
          [class.app-dropdown__panel--right]="!overlay() && position() === 'right'"
          [ngStyle]="overlay() ? overlayPanelStyle() : null"
          role="listbox"
        >
          @for (opt of options(); track opt.label) {
            <button
              type="button"
              class="app-dropdown__option"
              [class.app-dropdown__option--selected]="isSelected(opt)"
              role="option"
              [attr.aria-selected]="isSelected(opt)"
              (click)="select(opt)"
            >
              {{ opt.label }}
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
